module.exports = __webpack_public_path__ + "img/shower.96345884.svg";